import { Component, Vue } from "vue-property-decorator";

@Component
export default class ChevronRight extends Vue {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="14"
        viewBox="0 0 8 14"
      >
        <polygon
          fill="currentColor"
          fill-rule="evenodd"
          points="-1.355 3 4 7.945 9.355 3 11 4.522 4 11 -3 4.522"
          transform="rotate(-90 4 7)"
        />
      </svg>
    );
  }
}
